import { useQuery } from '@tanstack/react-query';
import { distributedPromoItemQueryOptions } from '../api/promotion.api';
import { PromoItemZmsView } from '../components/PromoItemZmsView';
import type { PromoDrillParams } from '../types/promotion.types';

const UNKNOWN_ITEM_TITLE = 'Promotional Item';

interface PromoItemZmsPageProps {
  promoItemId: number;
  zmSearch: PromoDrillParams;
}

export function PromoItemZmsPage({ promoItemId, zmSearch }: PromoItemZmsPageProps) {
  const itemQuery = useQuery(distributedPromoItemQueryOptions(promoItemId, zmSearch));
  const title = itemQuery.isLoading ? undefined : (itemQuery.data?.name ?? UNKNOWN_ITEM_TITLE);

  return (
    <PromoItemZmsView
      unit="promotion"
      promoItemId={promoItemId}
      zmSearch={zmSearch}
      title={title}
    />
  );
}
